@if (presentation(); as presentation) {
    <qpx-pill
        size="sm"
        icon="lucideBookOpenText"
        [label]="presentation.source.label"
        [context]="presentation.source.context"
        tone="muted"
        [decorative]="true"
        [darkenIconBackground]="true"
        [iconOnly]="compact()"
        [attr.aria-label]="compact() ? presentation.source.label : null"
        [attr.tabindex]="compact() ? 0 : null"
        [qpxTooltip]="presentation.source.label"
        [matTooltipDisabled]="!compact()"
    />
}
